import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import * as Types from 'apps/fleet-planner/types'

export const fetchExternalLoadFleetPlannerId = (
  externalLoadId: string
): Promise<Types.IGetExternalLoadFleetPlannerIdResponse> => {
  const requestData = {
    method: 'GET',
    endpoint: FP_ENDPOINTS.external_load_mp,
    id: externalLoadId,
  }
  return callApi(requestData)
}
